import React, { useEffect } from 'react';
import "../../assets/styles/Profile.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import iconUser from "../../icons/icon-user.png";
import iconPhone from "../../icons/icon-phone.png";
import iconMail from "../../icons/icon-mail.png";
import iconBank from "../../icons/icon-bank.png";
import iconBirthday from "../../icons/icon-birthday.png";
import iconChangePass from "../../icons/btn-change-pass.png";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import imgBtnBirthdayHover from "../../imgs/bt-change-birtday-hover.png";
import imgBottom from "../../imgs/img-bottom-cskh.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import HomeIcon from '@mui/icons-material/Home';

import * as yup from 'yup';


function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        navigate("/change-info",{ state: { userName, data, webSetting, typeModal } });
      }
    };

    return (
      <div className="container">
        <motion.div className="app">
          <Header isPageSearch={false} data={ {userName, data, webSetting} }  />
          <div className="content">
            <div className="profile">
              <InfoUser />
              <span className="profile-titlte title-btn-change">THAY ĐỔI MỤC THÔNG TIN MỚI</span>
              <div className="image-grid">
                  <button className="action-btn" onClick={() => changeInfo("full_name")}>
                    <img src={iconUser} alt="icon-user" />
                    THAY ĐỔI <br></br>
                    HỌ VÀ TÊN
                  </button>
                  <button className="action-btn" onClick={() => changeInfo("phone_number")}>
                    <img src={iconPhone} alt="icon-phone" />
                    THAY ĐỔI <br></br> SĐT
                  </button>
                  <button className="action-btn" onClick={() => changeInfo("email")}>
                    <img src={iconMail} alt="icon-mail" />
                    THAY ĐỔI <br></br> EMAIL
                  </button>
                  <button className="action-btn" onClick={() => changeInfo("bank")}>
                    <img src={iconBank} alt="icon-bank" />
                    ĐỔI STK <br></br> NGÂN HÀNG
                  </button>
                  <button className="action-btn" onClick={() => changeInfo("birthday")}>
                    <img src={iconBirthday} alt="icon-birthday" />
                    CẬP NHẬT <br></br> NGÀY SINH
                  </button>
                  <button
                    className="action-btn"
                    onClick={() => window.open('https://reset-pass-qq88.pages.dev/', '_blank')}
                  >
                    <img src={iconChangePass} alt="icon-birthday" />
                    ĐỔI MẬT KHẨU <br /> QUA EMAIL
                  </button>
              </div>
              {/* <div>
                <img className="img-bottom img-bottom-profile" alt="bottom" src={imgBottom} />
              </div> */}
            </div>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
